import { useSyncExternalStore } from "react";

/**
 * Erişim token'ı YALNIZCA bellekte tutulur (localStorage'a yazılmaz → XSS ile çalınamaz). Sayfa yenilenince
 * httpOnly çerezdeki refresh token ile sessizce yenisi alınır. Depo React dışından da okunabildiği için
 * API istemcisi ve WebSocket bağlantısı aynı kaynağı kullanır.
 */
export type AuthStatus = "unknown" | "authenticated" | "anonymous";

interface AuthState {
  status: AuthStatus;
  accessToken: string | null;
  accessTokenExpiresAt: number | null;
}

let state: AuthState = { status: "unknown", accessToken: null, accessTokenExpiresAt: null };
const listeners = new Set<() => void>();

function setState(next: AuthState): void {
  state = next;
  listeners.forEach((listener) => listener());
}

export const authStore = {
  getState: (): AuthState => state,
  getAccessToken: (): string | null => state.accessToken,
  setTokens(tokens: { accessToken: string; accessTokenExpiresAt: string }): void {
    setState({
      status: "authenticated",
      accessToken: tokens.accessToken,
      accessTokenExpiresAt: Date.parse(tokens.accessTokenExpiresAt),
    });
  },
  clear(): void {
    setState({ status: "anonymous", accessToken: null, accessTokenExpiresAt: null });
  },
  subscribe(listener: () => void): () => void {
    listeners.add(listener);
    return () => listeners.delete(listener);
  },
};

export function useAuthStatus(): AuthStatus {
  return useSyncExternalStore(authStore.subscribe, () => state.status);
}
